import { syncAjax, addDataSign } from './ajaxsync';
import { setGlobalStorage } from './storage';
import { getTopWindow } from './window.js';
import { getCookie } from './cookie';

export function getSysFieldid(fieldid) {
    if (NODE_ENV === 'development') {
        return fieldid;
    }
    // 条件前置 避免多次调用下面的逻辑  否则一个页面调用千次会导致卡顿
    if (window.automatedSwitch === '1') {
        return fieldid;
    }

    if (window.automatedSwitch === '0' || window.automatedSwitch === '3') {
        return null;
    }

    let NCC_SYS_Switch = JSON.parse(localStorage.getItem('NCC_SYS_Switch')) || {};

    let automatedSwitch = '0';

    if (NCC_SYS_Switch && NCC_SYS_Switch.hasOwnProperty('automated_test')) {
        automatedSwitch = NCC_SYS_Switch.automated_test ? "1" : '0';
    }

    if (NCC_SYS_Switch === null && automatedSwitch !== '3' && NODE_ENV !== 'development') {
        let reqData = { sysParamJson: { busiaction: '查询系统开关' } };
        let cookiets = (getTopWindow() && getTopWindow().cookiets) || getCookie('cookiets') || Date.now(); //双cookie验证 liuxis
        // 做一次 数据转型
        cookiets = isNaN(cookiets) ? cookiets : Number(cookiets);
        let headers = { 'Content-Type': 'application/json;charset=UTF-8', cookiets };
        reqData = JSON.stringify(addDataSign(reqData, '', { allin: true, headers: headers }));
        syncAjax({
            type: 'post',
            url: '/nccloud/platform/total/switch.do',
            headers: headers,
            async: false,
            data: reqData,
            success: res => {
                if (res) {
                    res = JSON.parse(res);
                    if (res && res.success) {
                        if (res.data) {
                            let NCC_SYS_Switch = res.data || {};
                            let localStorageSwitch = localStorage.getItem('storeCipher');
                            //缓存是否加密开关变化了
                            if (localStorageSwitch != NCC_SYS_Switch.localStorage) {
                                //localStorage加密开关与上次不一致，则清空所有localStorage内容
                                localStorage.clear();
                            }
                            localStorage.setItem('NCC_SYS_Switch', JSON.stringify(NCC_SYS_Switch));
                            localStorage.setItem('storeCipher', NCC_SYS_Switch.localStorage ? '1' : '0');
                            setGlobalStorage('localStorage', '_ncc_extend_style_', NCC_SYS_Switch.extendstyle ? '1' : '0');
                            if (NCC_SYS_Switch.automated_test) {
                                //开启关闭自动化测试开关
                                setGlobalStorage('localStorage', '_ncc_automated_', '1');
                                // 避免多次加
                                window.automatedSwitch = '1';
                                return fieldid;
                            } else {
                                //关闭自动化测试开关
                                setGlobalStorage('localStorage', '_ncc_automated_', '0');
                                // 避免多次加载
                                window.automatedSwitch = '0';
                                return null;
                            }
                        }
                    } else {
                        setGlobalStorage('localStorage', '_ncc_automated_', '3');
                        // 避免多次加载
                        window.automatedSwitch = '3';
                        console.log('自动化测试开关加载错误', res);
                    }
                }
            },
            error(res) {
                setGlobalStorage('localStorage', '_ncc_automated_', '3');
                console.log('自动化测试开关加载错误', res);
            },
        });
    } else if (automatedSwitch === '1') {
        // 避免多次加载
        window.automatedSwitch = '1';
        return fieldid;
    } else {
        // 避免多次加载
        window.automatedSwitch = automatedSwitch;
    }

    return null;
}

export function getSystemSwitch() {
    let NCC_SYS_Switch = JSON.parse(localStorage.getItem('NCC_SYS_Switch')) || {};
    let systemSwitch = {
        compress: NCC_SYS_Switch.gzip, //是否压缩
        encrypt: NCC_SYS_Switch.aesKey, //是否加密
        mark: NCC_SYS_Switch.mark, //是否加签
        automated: NCC_SYS_Switch.automated_test, //是否开启自动化测试
        merge: NCC_SYS_Switch.isMerged, //是否是合盘换行
        encryptStorage: NCC_SYS_Switch.localstorage, //是否加密localStorage
        timezone: NCC_SYS_Switch.timezone, //服务器时区
        conversionTime: NCC_SYS_Switch.timezoneswitch, //是否转换时区
    };
    return systemSwitch;
}

